module.exports = __webpack_public_path__ + "static/media/Asset 11RLKnee.3281ffcb.png";